/* tslint:disable */
/* eslint-disable */
export enum OrderRowSupplyEntryTypeEnum {
  Partial = 0,
  Total = 1,
}
